import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import JobPhotoCard from './JobPhotoCard';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  }
});


const JobPhotoCards = ({ classes, files, handleEdit }) => {
  return(
    <div className={classes.root}>
      {files &&
        files.map((file, i) => {
          return <JobPhotoCard key={i} file={file} handleEdit={handleEdit}/>;
        })
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const id = props.project.id;
  return ({
    files: state.filesState.filter ( file => {
      return (file.projectId === id && file.category === "photo");
    }),
  });
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(JobPhotoCards);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Photos/JobPhotoCards.jsx